export function isDefined<T>(arg: T | null | undefined): arg is T {
  // != null is the same as !== null && !== undefined
  return arg != null;
}
